import api from "@/router/api";

let cacheUnidadesTodas = null;

export default {
  async getAllUnidades(page, size) {
    if (size >= 1000 && cacheUnidadesTodas) {
      return cacheUnidadesTodas;
    }

    const response = await api.get("/unidades", {
      params: { page, size },
      public: true,
    });

    if (size >= 1000) {
      cacheUnidadesTodas = response.data?.content || response.data;
    }
    return response.data?.content || response.data;
  },

  async postUnidades(name) {
    const response = await api.post("/unidades", { nome: name });
    return response.data;
  },

  async getUnidadesById(unidadeId) {
    const response = await api.get(`/unidades/${unidadeId}`);
    return response.data;
  },

  async getUnidadesByNome(nome) {
    const response = await api.get("/unidades/busca", {
      params: { nome },
    });
    return response.data;
  },
};
